export const CountryResource = {
  id: null,
  name: '',
  currency_symbol: '',
}
